import { useState } from "react";
import { Button, Box, TextField, Typography } from "@mui/material";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import LegitCheckService from "../../services/legitCheckService";
import DialogService from "../Dialog/dialogService";
import NotificationService from "../Notification/notificationService";

interface NewLegitCheckProps {
  itemId: number;
  setLegitChecked: Function;
}

const NewLegitCheck = ({ itemId, setLegitChecked }: NewLegitCheckProps) => {
  const [legit, setLegit] = useState<boolean | undefined>(undefined);
  const [comment, setComment] = useState<string>("");

  const { postLegitCheck } = LegitCheckService();
  const { close } = DialogService();
  const { success, error } = NotificationService();

  const sendLegitCheck = () => {
    if (comment !== "") {
      if (legit !== undefined) {
        postLegitCheck(itemId, comment, legit).then((result) => {
          if (result) {
            close();
            success("Legit check sent successfully");
            setLegitChecked(true);
          } else {
            error("Cannot legit check twice the same item.");
          }
        });
      } else {
        error("Please select your option first.");
      }
    } else {
      error("Comment field is mandatory");
    }
  };

  const legitStyle = {
    backgroundColor: "#07b628 !important",
    color: "white !important",
    width: { xs: "120px !important", sm: "180px !important" },
    fontSize: { xs: "14px !important", sm: "18px !important" },
  };

  const legitSelectedStyle = {
    backgroundColor: "#a6e6b2 !important",
    color: "#07b628 !important",
    border: "2px solid #07b628",
    width: { xs: "120px !important", sm: "180px !important" },
    fontSize: { xs: "14px !important", sm: "18px !important" },
  };

  const notLegitStyle = {
    backgroundColor: "#fb2323 !important",
    color: "white !important",
    width: { xs: "120px !important", sm: "180px !important" },
    fontSize: { xs: "14px !important", sm: "18px !important" },
  };

  const notLegitSelectedStyle = {
    backgroundColor: "#ffdddd !important",
    color: "#fb2323 !important",
    border: "2px solid #fb2323",
    width: { xs: "120px !important", sm: "180px !important" },
    fontSize: { xs: "14px !important", sm: "18px !important" },
  };

  const cancelStyle = {
    backgroundColor: "white !important",
    color: "#4695ff !important",
    border: "2px solid #4695ff",
    width: { xs: "120px !important", sm: "180px !important" },
    fontSize: { xs: "14px !important", sm: "18px !important" },
  };

  return (
    <Box>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          columnGap: 1,
          marginBottom: "1rem",
        }}
      >
        <Box>
          <Button
            variant="blue"
            sx={legit === true ? legitSelectedStyle : legitStyle}
            onClick={() => setLegit(true)}
          >
            Legit
          </Button>
        </Box>
        <Box>
          <Typography
            variant="body1"
            sx={{ fontSize: "1rem !important", fontWeight: "700 !important" }}
          >
            Or
          </Typography>
        </Box>
        <Box>
          <Button
            variant="blue"
            sx={legit === false ? notLegitSelectedStyle : notLegitStyle}
            onClick={() => setLegit(false)}
          >
            Not Legit
          </Button>
        </Box>
      </Box>

      <Box sx={{ width: "100%" }}>
        <Box sx={{ width: "100%" }}>
          <TextField
            value={comment}
            onChange={(e) => setComment(e.target.value)}
            multiline
            rows={10}
            fullWidth
            inputProps={{ maxLength: 255 }}
          />
        </Box>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            columnGap: 1,
            marginY: "1rem",
          }}
        >
          <Box>
            <Typography variant="body1" sx={{ color: "#fb2323 !important" }}>
              <WarningAmberIcon fontSize="small" />
            </Typography>
          </Box>
          <Box>
            <Typography
              variant="body1"
              sx={{
                fontSize: "0.75rem !important",
                fontWeight: "700 !important",
              }}
            >
              It is mandatory to write a comment to rate the shirt.
            </Typography>
          </Box>
        </Box>
      </Box>

      <Box
        sx={{
          display: "flex",
          flexDirection: "row",
          justifyContent: "end",
          columnGap: 2,
        }}
      >
        <Box>
          <Button
            onClick={close}
            sx={{
              backgroundColor: "white !important",
              color: "#4665ff !important",
              border: "2px solid #4665ff",
              width: { xs: "120px !important", sm: "180px !important" },
              fontSize: { xs: "14px !important", sm: "18px !important" },
              boxSizing: "border-box !important",
            }}
          >
            Cancel
          </Button>
        </Box>
        <Box>
          <Button
            onClick={sendLegitCheck}
            disabled={legit === undefined || comment === ""}
            sx={{
              backgroundColor: "#4665ff !important",
              color: "#fff !important",
              border: "2px solid #4665ff",
              width: { xs: "120px !important", sm: "180px !important" },
              fontSize: { xs: "14px !important", sm: "18px !important" },
            }}
          >
            Send
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default NewLegitCheck;
